"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = function _default(type) {
  return type === "amp4email" ? "EMAIL" : type === "amp4ads" ? "ADS" : null;
};
exports["default"] = _default;